import http from '../../services/httpService';

export const getUserData  = async (userId) => await http.get('/user/${userId}/');
export const updateProfile = async(data)   => await http.put('/update_profile/', data);
